import React from 'react'
import BannerImg from '../../assets/bg_image.webp'
import { banner_packing_match } from '../../assets/updated_assests/assets'

const CityBreak = () => {
  return (
    <div>
      <div className="banner min-h-[700px] w-full !bg-cover !bg-no-repeat text-center" style={{
        background: `url(${banner_packing_match})`,

      }} >
        <div className="grid bg-[#25231B80] md:grid-cols-5  grid-cols-1 min-h-[700px]">
          <div className=" w-full min-h-[700px] flex col-span-2 justify-center items-end p-4 md:pl-12">
            <div className="">
              <h3 className='text-white text-left font-roboto-mono font-bold italic md:text-[2.5rem] text-[1.8rem]' >
                Find Your Perfect Packing List
              </h3>
              <p className='text-white font-quicksand font-medium text-[16px] text-left ' >Select your destination and packing needs to reveal a tailored packing list. Use it as is or adjust to fit your style!</p>
              {/* <div className="text-left mt-5 ">
                <Link to="/products" className='flex  items-center gap-1 w-fit border-2 border-darkGreen px-5 py-2 font-quicksand text-darkGreen font-bold text-[16px] bg-white mb-5 ' > <MdArrowOutward />  Explore & Early bird access </Link>
              </div> */}

            </div>
          </div>
        </div>


      </div>
    </div>
  )
}

export default CityBreak
